<template>
  <b-modal
    v-model="show"
    title="Completar datos de conductores para días libres"
    modal-class="modal-warning"
    size="lg"
    no-close-on-backdrop
    @hidden="onHidden"
  >
    <b-overlay :show="loading" rounded="sm">
      <b-alert show variant="warning" class="p-1 mb-2">
        <feather-icon icon="AlertTriangleIcon" class="mr-50" />
        Los siguientes conductores no generan días libres automáticamente porque no tienen asignado un <strong>régimen laboral</strong> en su registro salarial vigente. Asigna el régimen correspondiente para calcular su meta mensual.
      </b-alert>

      <div v-if="pendientes.length === 0 && !loading" class="text-center py-2 text-muted">
        <feather-icon icon="CheckCircleIcon" size="32" class="text-success mb-1" />
        <h5>¡Excelente! Todos los conductores tienen su régimen y sueldo asignados.</h5>
      </div>

      <div v-else class="table-responsive" style="max-height: 400px; overflow-y: auto;">
        <table class="table table-sm table-hover font-small-3">
          <thead>
            <tr>
              <th>CONDUCTOR</th>
              <th>DOCUMENTO</th>
              <th>ESTADO ACTUAL</th>
              <th style="min-width: 220px;">ASIGNAR RÉGIMEN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in pendientes" :key="item.personal_id">
              <td>
                <strong>{{ item.empleado }}</strong>
                <div v-if="item.fecha_ingreso" class="text-muted small">
                  Ingreso: {{ item.fecha_ingreso }}
                </div>
              </td>
              <td>{{ item.documento }}</td>
              <td>
                <b-badge v-if="item.sin_sueldo" variant="light-danger" class="mr-25">
                  Sin Sueldo
                </b-badge>
                <b-badge v-if="item.sin_regimen" variant="light-warning">
                  Sin Régimen
                </b-badge>
                <b-badge v-else-if="item.regimen_invalido" variant="light-danger">
                  Régimen Inválido
                </b-badge>
              </td>
              <td>
                <b-form-select
                  v-model="item.selected_regimen"
                  size="sm"
                  :options="regimenOptions"
                >
                  <template #first>
                    <b-form-select-option :value="null" disabled>
                      -- Seleccionar Régimen --
                    </b-form-select-option>
                  </template>
                </b-form-select>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-overlay>

    <template #modal-footer>
      <b-button variant="outline-secondary" @click="show = false">
        Cerrar
      </b-button>
      <b-button
        variant="warning"
        :disabled="loading || asignacionesValidas.length === 0"
        @click="guardarAsignaciones"
      >
        <feather-icon icon="SaveIcon" class="mr-50" />
        Guardar Asignaciones ({{ asignacionesValidas.length }})
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import DiasLibresService from "../service/dias-libres.service";

export default {
  name: "CompletarDatosModal",
  data() {
    return {
      show: false,
      loading: false,
      pendientes: [],
      regimenes: [],
    };
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
    regimenOptions() {
      return this.regimenes.map((r) => ({
        value: r.id,
        text: r.nombre,
      }));
    },
    asignacionesValidas() {
      return this.pendientes
        .filter((p) => p.selected_regimen !== null && p.selected_regimen !== undefined)
        .map((p) => ({
          personal_id: p.personal_id,
          tipo_acuerdo_id: p.selected_regimen,
        }));
    },
  },
  methods: {
    async open() {
      this.show = true;
      await this.cargarDatos();
    },
    async cargarDatos() {
      this.loading = true;
      try {
        const { data } = await DiasLibresService.getDatosPendientes();
        this.regimenes = data.regimenes || [];
        this.pendientes = (data.pendientes || []).map((p) => ({
          ...p,
          selected_regimen: null,
        }));
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error",
            text: "No se pudieron obtener los conductores pendientes.",
            icon: "AlertCircleIcon",
            variant: "danger",
          },
        });
      } finally {
        this.loading = false;
      }
    },
    async guardarAsignaciones() {
      if (this.asignacionesValidas.length === 0) return;

      this.loading = true;
      try {
        const user = (this.currentUser && (this.currentUser.id || this.currentUser.user_id))
          ? this.currentUser
          : (JSON.parse(localStorage.getItem("userData")) || {});
        const userId = user.id || user.user_id;

        await DiasLibresService.asignarRegimen({
          asignaciones: this.asignacionesValidas,
          id_usuario: userId,
        });

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Régimen asignado",
            text: `Se asignó el régimen a ${this.asignacionesValidas.length} conductor(es) correctamente.`,
            icon: "CheckCircleIcon",
            variant: "success",
          },
        });

        this.show = false;
        this.$emit("saved");
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error al guardar",
            text: error.response?.data?.message || "Ocurrió un error al asignar los regímenes.",
            icon: "AlertCircleIcon",
            variant: "danger",
          },
        });
      } finally {
        this.loading = false;
      }
    },
    onHidden() {
      this.pendientes = [];
    },
  },
};
</script>
